module.exports = __webpack_public_path__ + "static/media/minhduyen-footer.37a24edd.png";